<div class="row retiree-deductions nova-font-style">
  <div class="col s12 m10 offset-m1 l8 offset-l2 xl6 offset-xl3 remove-default-padding">
    <h2>Retiree Deductions</h2>
    <div>
      <kendo-tabstrip [animate]="true" [tabAlignment]="'justify'">
        <kendo-tabstrip-tab title="Upload" [selected]="true">
          <ng-template kendoTabContent>
            <div id="upload-form">
              <div class="form-layout top-padding-20">
                <form #myForm="ngForm" novalidate [formGroup]="editForm">
                  <div class="upload-form">
                    <div class="row">
                      <div class="col s12 m12 l6 xl4 bold" id="rCount">Record Count:</div>
                      <div class="col s12 m12 l6 xl8">
                        <kendo-numerictextbox id="recordCount" class="form-control" [format]="'n0'"
                          formControlName="recordCount" [value]="0" [min]="0" [max]="maxRecordCount"
                          [autoCorrect]="true" [spinners]="false">
                        </kendo-numerictextbox>
                        <span *ngIf="editForm.controls.recordCount.invalid" id="rc-warning"
                          class="validationError">{{config.RecordCountWarning}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col s12 m12 l6 xl4 bold" id="tAmount">Total Amount:</div>
                      <div class="col s12 m12 l6 xl8">
                        <kendo-numerictextbox id="totalCount" formControlName="totalAmount" class="form-control"
                          [format]="'c'" [value]="0" [min]="0" [max]="maxAmount" [autoCorrect]="true" [spinners]="false"
                          [decimals]="decimals">
                        </kendo-numerictextbox>
                        <span *ngIf="editForm.controls.totalAmount.invalid" id="ta-warning"
                          class="validationError">{{config.AmountWarning}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col s12 m12 l6 xl4 bold">Process Month:</div>
                      <div class="col s12 m12 l6 xl8">
                        <kendo-datepicker id="processMonth" (ngModelChange)='setModel($event)' [format]="'MMMM'"
                          [min]="minDate" [max]="maxDate" [value]="pped" class="form-control" formControlName="pped"
                          [ngModelOptions]="{standalone: true}" [navigation]="false" [activeView]="'year'"
                          [bottomView]="'year'" [placeholder]="'Please type or select the process month'">
                        </kendo-datepicker>
                      </div>
                    </div>
                    <div class="row text-area-resize">
                      <div class="col s12 m12 l6 xl4 bold" id="notes">Comments (Optional):</div>
                      <div class="col s12 m12 l6 xl8">
                        <textarea class="k-textarea" kendoTextArea [autoSize]="true" maxlength="240"
                          formControlName="notes" aria-label="notes" id="textArea" class="full-width"></textarea>
                      </div>
                    </div>
                    <div class="left-margin-10 file-upload">
                      <kendo-upload #myUpload class="kendo-upload" [autoUpload]="false" [saveUrl]="uploadSaveUrl"
                        [multiple]="false" [removeUrl]="uploadRemoveUrl" [restrictions]="config.UploadFileRestrictions"
                        (complete)="uploadComplete(myUpload)" (upload)="uploadEventHandler($event, myForm.value)"
                        (success)="uploadSuccess($event)" (select)="selectEventHandler($event)"
                        (error)="errorEventHandler()">
                        <kendo-upload-messages select="Select a file..">
                        </kendo-upload-messages>
                      </kendo-upload>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="History">
          <ng-template kendoTabContent>
            <app-upload-history [fileType]="'Deductions'"></app-upload-history>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
  </div>
</div>
